import React from "react";
import { useProject } from "../../state/ProjectContext";
import EditableTable from "./_EditableTable";
import { Radio } from "lucide-react";

export default function Cutover() {
  const { doc } = useProject();
  const runbook = doc?.cutover?.runbook || [];
  const hypercare = doc?.cutover?.hypercare || [];

  // War-room dashboard KPIs
  const total = runbook.length;
  const done = runbook.filter(r => r.status === "Complete").length;
  const blocked = runbook.filter(r => r.status === "Blocked").length;
  const inFlight = runbook.filter(r => r.status === "In progress").length;
  const openHc = hypercare.filter(h => !["Closed", "Resolved"].includes(h.status)).length;

  return (
    <>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 section-eyebrow">Cutover &amp; Hypercare</div>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900 mt-1">Cutover</h2>
        <p className="text-sm text-zinc-500 mt-1 max-w-3xl">Run-book with sequencing &amp; rollback triggers · command-center dashboard · hypercare SLA log.</p>
      </div>

      {/* War-room KPIs */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-5" data-export-capture="cutover-kpis" data-export-title="Cutover · War Room">
        <div className="card p-4"><div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">Runbook tasks</div><div className="font-display text-2xl font-extrabold text-zinc-900 mt-1">{total}</div></div>
        <div className="card p-4"><div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">Complete</div><div className="font-display text-2xl font-extrabold text-green-700 mt-1">{done}</div></div>
        <div className="card p-4"><div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">In flight</div><div className="font-display text-2xl font-extrabold text-blue-700 mt-1">{inFlight}</div></div>
        <div className="card p-4"><div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">Blocked</div><div className="font-display text-2xl font-extrabold text-red-700 mt-1">{blocked}</div></div>
        <div className="card p-4"><div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">Open hypercare</div><div className="font-display text-2xl font-extrabold text-amber-700 mt-1">{openHc}</div></div>
      </div>

      {/* Cutover runbook */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Radio size={14} className="text-red-600"/>
          <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500">Cutover run-book · sequenced with dependencies &amp; rollback triggers</div>
        </div>
        <EditableTable
          sectionKey="cutover"
          listKey="runbook"
          testidPrefix="rb"
          labelSingular="step"
          columns={[
            { key: "seq", label: "#", type: "number", width: "60px" },
            { key: "task", label: "Task" },
            { key: "dependsOn", label: "Depends on", width: "110px" },
            { key: "owner", label: "Owner", width: "130px" },
            { key: "startPlan", label: "Plan start", type: "date", width: "140px" },
            { key: "durationMin", label: "Duration min", type: "number", width: "120px" },
            { key: "rollbackTrigger", label: "Rollback trigger" },
            { key: "status", label: "Status", type: "select", options: ["Not started", "In progress", "Complete", "Blocked", "Skipped"], width: "130px" },
          ]}
          emptyRow={() => ({ seq: (doc?.cutover?.runbook?.length || 0) + 1, task: "", dependsOn: "", owner: "", startPlan: "", durationMin: 0, rollbackTrigger: "", status: "Not started" })}
        />
      </div>

      {/* Hypercare log */}
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Hypercare issue log · SLA-tracked</div>
        <EditableTable
          sectionKey="cutover"
          listKey="hypercare"
          testidPrefix="hc"
          labelSingular="ticket"
          columns={[
            { key: "ref", label: "Ref", width: "80px" },
            { key: "title", label: "Title" },
            { key: "severity", label: "Severity", type: "select", options: ["P1", "P2", "P3", "P4"], width: "100px" },
            { key: "slaHours", label: "SLA hrs", type: "number", width: "90px" },
            { key: "opened", label: "Opened", type: "date", width: "140px" },
            { key: "owner", label: "Owner", width: "120px" },
            { key: "status", label: "Status", type: "select", options: ["Open", "In progress", "On hold", "Resolved", "Closed"], width: "120px" },
          ]}
          emptyRow={() => ({ ref: `HC-${String(((doc?.cutover?.hypercare || []).length || 0) + 1).padStart(4, "0")}`, title: "", severity: "P3", slaHours: 24, opened: new Date().toISOString().split("T")[0], owner: "", status: "Open" })}
        />
      </div>
    </>
  );
}
